module.exports = __webpack_public_path__ + "static/media/jingshi.2c82a322.png";